import { Store } from "pullstate";
import { ProductStore } from "./ProductStore";

// Load initial state from localStorage or use default state
const initialState = JSON.parse(localStorage.getItem('drukshop_cartStore')) || {
    total: 0,
    product_ids: []
};

export const CartStore = new Store(initialState);

export const addToCart = (categorySlug, productID) => {
    const allProducts = ProductStore.getRawState().products;
    const category = allProducts.find(p => p.slug === categorySlug);
    const product = category ? category.products.find(p => p.id === parseInt(productID)) : null;

    if (!product) {
        console.error("Attempted to add a non-existent product to the cart.");
        return; // Do not add if product doesn't exist
    }

    const productStock = product.stock;

    CartStore.update(s => {
        // Find if the product already exists in the cart
        const existingCartItem = s.product_ids.find(item => 
            item.categorySlug === categorySlug && item.productID === parseInt(productID)
        );

        if (existingCartItem) {
            // If it exists, increment the quantity, but not beyond the available stock
            if (existingCartItem.quantity < productStock) {
                existingCartItem.quantity++;
            } else {
                // Optionally, you can add a toast notification here to inform the user
                console.warn(`Cannot add more of ${product.name}. Stock limit reached.`);
            }
        } else {
            // If it doesn't exist, add it to the cart with quantity 1
            s.product_ids.push({ 
                categorySlug, 
                productID: parseInt(productID), 
                quantity: 1 
            });
        }
    });

    localStorage.setItem('drukshop_cartStore', JSON.stringify(CartStore.getRawState()));
}

export const removeFromCart = (productIndex) => {
    CartStore.update(s => {
        if (productIndex > -1 && productIndex < s.product_ids.length) {
            s.product_ids.splice(productIndex, 1);
        }
    });

    localStorage.setItem('drukshop_cartStore', JSON.stringify(CartStore.getRawState()));
}

export const cleanCart = () => {
    // New function to remove all invalid items at once.
    const currentProducts = CartStore.getRawState().product_ids;
    const allProducts = ProductStore.getRawState().products;

    const validCartItems = currentProducts.filter(cartItem => {
        const tempCategory = allProducts.find(p => p.slug === cartItem.categorySlug);
        const tempProduct = tempCategory ? tempCategory.products.find(p => parseInt(p.id) === parseInt(cartItem.productID)) : null;
        return !!tempProduct; // Returns true if the product exists, false otherwise.
    });

    // Update the store with only the valid items.
    CartStore.update(s => {
        s.product_ids = validCartItems;
    });
    localStorage.setItem('drukshop_cartStore', JSON.stringify(CartStore.getRawState()));
};

export const updateCartItem = (productIndex, newDeliveryLocID = null, dzo = null, address = null, price = null, data = [], quantity = null, note = '', deliveryMode, attributes = {}) => {
    // Update the object at the specified index
    if(address){
        CartStore.update(s => {
            let product = s.product_ids[productIndex];
            product.address = address;
        });
    } else {
        CartStore.update(s => {
            let product = s.product_ids[productIndex];
            let qty = (product.quantity > 1 && quantity == null) ? product.quantity : quantity;
            product.newDeliveryLocID = newDeliveryLocID;
            product.dzo = dzo;
            product.address = address;
            product.price = price;
            product.data = data;
            product.quantity = qty ? qty : 1;
            product.note = note;
            product.deliveryMode = deliveryMode;
            //Update attributes if provided, otherwise keep existing attributes
            product.attributes = attributes && Object.keys(attributes).length > 0 ? attributes : product.attributes || {};
        });
    }

    localStorage.setItem('drukshop_cartStore', JSON.stringify(CartStore.getRawState()));
}

export const resetCart = () => {
    // Remove drukshop_cartStore from localStorage
    localStorage.removeItem('drukshop_cartStore');
    
    CartStore.update(s => {
        s.total = 0;
        s.product_ids = [];
    }); 
};

// Save state to localStorage before window is closed
window.onbeforeunload = () => {
    //localStorage.setItem('drukshop_cartStore', JSON.stringify(CartStore.getRawState()));
};